import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Love from "../../assets/icons/love.png";

const text = "What does your business \xa0to do?";

const TypeWriter = () => {
  const [index, setIndex] = useState(0);
  const [subIndex, setSubIndex] = useState(0);

  // typeWriter
  useEffect(() => {
    if (index === text.length) return;

    const timeout = setTimeout(() => {
      setIndex((prev) => prev + 1);
      setSubIndex((prev) => prev + 1);
    }, 75);
    return () => clearTimeout(timeout);
  }, [subIndex, index]);

  return (
    <div className="typeWriter">
      {/*            What does your<br />
            business <img src="./Assets/love.svg" alt="love" /> to do?*/}

      {subIndex < 15 && <span>{text.substring(0, subIndex)}</span>}
      {subIndex > 14 && subIndex < 25 && (
        <span>
          {text.substring(0, 14)}
          <br />
          {text.substring(14, subIndex)}
        </span>
      )}

      {subIndex > 24 && (
        <span>
          <span>
            {text.substring(0, 14)}
            <br />
            {text.substring(14, 24)}
          </span>
          <span>
            <motion.img
              className="heartImg"
              animate={{ scale: [1.5, 2, 1.5] }}
              src={Love}
              alt="love"
            />
          </span>
          <span>{text.substring(24, subIndex)}</span>
        </span>
      )}
    </div>
  );
};

export default TypeWriter;
